// extracted by mini-css-extract-plugin
export default {"section-container":"Section_section-container__H4qTx","section-title":"Section_section-title__rZntS","section-content":"Section_section-content__y14TU"};